import { all, put, takeLatest, call } from 'redux-saga/effects';
import get from 'lodash/get';
import { enqueueSnackbarAction } from '../containers/App/actions';
import {
  getCountriesAction,
  tokenLoginAction,
  remoteLogoutAction,
  setIsLoggedInAction,
  tokenLoginLoadingnAction,
  getUserConstants,
} from './actions';
import * as API from '../utils/API';

import appSaga, { fetchCommonUserData } from '../containers/App/saga';
import accountSubscriptionSagas from '../containers/AccountSubscriptions/saga';
import articleSaga from '../containers/Article/saga';
import articlesSaga from '../containers/Articles/saga';
import artistSaga from '../containers/Artist/saga';
import composerSaga from '../containers/Composer/saga';
import artistsSaga from '../containers/Artists/saga';
import castSaga from '../containers/CastTools/saga';
import companiesSaga from '../containers/Companies/saga';
import companySaga from '../containers/Company/saga';
import competitionSaga from '../containers/Competition/saga';
import homeSaga from '../containers/Home/saga';
import managersByCountrySaga from '../containers/ManagersByCountry/saga';
import managersSaga from '../containers/Managers/saga';
import onthisdaySaga from '../containers/Onthisday/saga';
import ProductionUpdateSaga from '../containers/ProductionUpdateSteps/saga';
import rentalSaga from '../containers/Rental/saga';
import rentalsSaga from '../containers/Rentals/saga';
import seasonsPageSaga from '../containers/SeasonsPage/saga';
import settingsSaga from '../containers/AccountSettings/saga';
import statisticsSaga from '../containers/Statistics/saga';
import venuesSaga from '../containers/Venues/saga';
import festivalsSaga from '../containers/Festivals/saga';
import festivalSaga from '../containers/Festival/saga';
import workSaga from '../containers/Work/saga';
import registrationSaga from '../containers/Registration/saga';
import { setIntervalForPing } from '../utils/common';
import venueModalSaga from '../containers/VenueModal/saga';

export function* fetchCountries({ payload }) {
  try {
    const response = yield call(API.getCountries, payload);
    yield put(getCountriesAction.success(get(response, 'data.data')));
  } catch (err) {
    yield put(getCountriesAction.failure(err.message));
  } finally {
    yield put(getCountriesAction.fulfill());
  }
}

export function* getUserDetailsByToken({ payload }) {
  try {
    const userToken = payload.token;
    const userData = yield call(API.refreshToken, userToken);
    yield put(setIsLoggedInAction(true));
    yield call(fetchCommonUserData, {
      payload: {
        user: userData.data.user,
        token: userToken,
      },
    });
    yield put(tokenLoginAction.success(userToken));
    if (payload.isGoogleLogin) {
      setIntervalForPing();
    }
  } catch (err) {
    yield put(
      enqueueSnackbarAction({
        message: err.message,
        options: {
          variant: 'error',
        },
      }),
    );
    yield put(tokenLoginAction.failure(err.message));
  } finally {
    yield put(tokenLoginAction.fulfill());
  }
}

export function* remoteLogoutUser() {
  try {
    yield call(API.remoteLogout);
    yield put(tokenLoginLoadingnAction(true));
    yield put(remoteLogoutAction.success(false));
  } catch (err) {
    yield put(remoteLogoutAction.failure(err.message));
  } finally {
    yield put(remoteLogoutAction.fulfill());
  }
}

export function* fetchConstants() {
  try {
    const response = yield call(API.getConstants);
    yield put(getUserConstants.success(get(response, 'data.data')));
  } catch (err) {
    yield put(getUserConstants.failure(err.message));
  } finally {
    yield put(getUserConstants.fulfill());
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(getCountriesAction.TRIGGER, fetchCountries),
    takeLatest(tokenLoginAction.TRIGGER, getUserDetailsByToken),
    takeLatest(remoteLogoutAction.TRIGGER, remoteLogoutUser),
    takeLatest(getUserConstants.TRIGGER, fetchConstants),
    appSaga(),
    accountSubscriptionSagas(),
    articleSaga(),
    articlesSaga(),
    artistSaga(),
    composerSaga(),
    artistsSaga(),
    castSaga(),
    companiesSaga(),
    companySaga(),
    competitionSaga(),
    homeSaga(),
    managersByCountrySaga(),
    managersSaga(),
    onthisdaySaga(),
    ProductionUpdateSaga(),
    rentalSaga(),
    rentalsSaga(),
    seasonsPageSaga(),
    settingsSaga(),
    statisticsSaga(),
    venuesSaga(),
    festivalSaga(),
    festivalsSaga(),
    workSaga(),
    registrationSaga(),
    venueModalSaga(),
  ]);
}
